import { render, staticRenderFns } from "./company-oems-card-edit.vue?vue&type=template&id=5bfa1194&scoped=true&"
import script from "./company-oems-card-edit.vue?vue&type=script&lang=js&"
export * from "./company-oems-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./company-oems-card-edit.vue?vue&type=style&index=0&id=5bfa1194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa1194",
  null
  
)

export default component.exports